"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTakeWhile = exports.applyTakeLast = exports.applyTakeEvery = exports.applyTake = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyTake(factory, src, count) {
    if (count <= 0) {
        throw new Error('Count must be greater than 0');
    }
    function* generator() {
        let i = 0;
        for (const item of src) {
            if (i >= count) {
                return;
            }
            i++;
            yield item;
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyTake = applyTake;
function applyTakeEvery(factory, src, step) {
    if (step <= 0) {
        throw new Error('Count must be greater than 0');
    }
    return factory.createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(src)).where((_, i) => i % step === 0);
}
exports.applyTakeEvery = applyTakeEvery;
function applyTakeLast(factory, src, count) {
    if (count <= 0) {
        throw new Error('Count must be greater than 0');
    }
    function* generator() {
        const arr = [...src];
        for (let i = Math.max(arr.length - count, 0); i < arr.length; i++) {
            yield arr[i];
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyTakeLast = applyTakeLast;
function applyTakeWhile(factory, src, predicate) {
    function* generator() {
        let i = 0;
        for (const item of src) {
            if (!predicate(item, i)) {
                return;
            }
            i++;
            yield item;
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyTakeWhile = applyTakeWhile;
//# sourceMappingURL=applyTake.js.map